import { Tabs } from "./model";
import { SkuForm } from "./components/SkuForm";
import { SearchQueryBrandForm } from "./components/QueryBrand";
import { SearchQueryAsinForm } from "./components/SearchQuery";
import { AdsTimeBudgetForm } from "./components/AdsTimeBudgetForm";
import { SearchQueryPerformanceForm } from "./components/SearchQueryPerformanceForm";
import { SearchQueryProductForm } from "./components/SearchQueryProductForm";
import { SearchQueryGeographyForm } from "./components/SearchQueryGeographyForm";
import { COGSForm } from "./components/SearchCOGS";

export const tabs: Tabs[] = [
  "COGS",
  "SKU",
  "Search Query Brand",
  "Search Query ASIN",
  "Ads Time Budget",
  "Search Query Performance",
  "Search Query Product",
  "Search Query GEOGRAPHY",
];

export const getTitle = (tab: Tabs) => {
  switch (tab) {
    case "SKU":
      return "Add SKU Data Entry";
    case "Search Query Brand":
      return "Add Search Query Brand Data Entry";
    case "Search Query ASIN":
      return "Add Search Query ASIN Data Entry";
    case "Ads Time Budget":
      return "Add Ads Time Budget Data Entry";
    case "Search Query Performance":
      return "Add Search Query Performance Data Entry";
    case "Search Query Product":
      return "Add Search Query Product Data Entry";
    case "Search Query GEOGRAPHY":
      return "Add Search Query Geography Data Entry";
    case "COGS":
      return "Add COGS Data Entry";
    default:
      return "";
  }
};

export const getFormComponent = (
  tab: Tabs,
  formId: string,
  onSubmit?: () => void,
) => {
  switch (tab) {
    case "SKU":
      return <SkuForm formId={formId} onSubmit={onSubmit} />;
    case "Search Query Brand":
      return <SearchQueryBrandForm formId={formId} onSubmit={onSubmit} />;
    case "Search Query ASIN":
      return <SearchQueryAsinForm formId={formId} onSubmit={onSubmit} />;
    case "Ads Time Budget":
      return <AdsTimeBudgetForm formId={formId} onSubmit={onSubmit} />;
    case "Search Query Performance":
      return <SearchQueryPerformanceForm formId={formId} onSubmit={onSubmit} />;
    case "Search Query Product":
      return <SearchQueryProductForm formId={formId} onSubmit={onSubmit} />;
    case "Search Query GEOGRAPHY":
      return <SearchQueryGeographyForm formId={formId} onSubmit={onSubmit} />;
    case "COGS":
      return <COGSForm formId={formId} onSubmit={onSubmit} />;
    default:
      return <div />;
  }
};
